// Web Speech API helper for Arabic text-to-speech.
// Tries server-side OpenAI TTS first (cached MP3), falls back to browser SpeechSynthesis.

let cachedArabicVoice = null;
let currentAudio = null;

function pickArabicVoice() {
  if (cachedArabicVoice) return cachedArabicVoice;
  if (typeof window === 'undefined' || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices() || [];
  cachedArabicVoice = voices.find((v) => /^ar-SA/i.test(v.lang))
    || voices.find((v) => /^ar-EG/i.test(v.lang))
    || voices.find((v) => /^ar/i.test(v.lang))
    || null;
  return cachedArabicVoice;
}

function speakBrowser(text, { rate = 0.85, onEnd, onError } = {}) {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    onError && onError(new Error('TTS not supported'));
    return null;
  }
  try { window.speechSynthesis.cancel(); } catch (_) { /* noop */ }
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = 'ar-SA';
  utter.rate = rate;
  const voice = pickArabicVoice();
  if (voice) utter.voice = voice;
  utter.onend = () => onEnd && onEnd();
  utter.onerror = (e) => onError && onError(e);
  window.speechSynthesis.speak(utter);
  return utter;
}

/**
 * Speaks Arabic text. Prefers server-side OpenAI TTS (high quality, cached);
 * falls back to browser speechSynthesis if the server is unavailable.
 */
export async function speakArabic(text, { rate = 0.85, voice = 'nova', onEnd, onError } = {}) {
  if (!text) return;
  // Stop any ongoing audio first
  try { if (currentAudio) { currentAudio.pause(); currentAudio.src = ''; } } catch (_) { /* noop */ }
  try { if (typeof window !== 'undefined' && window.speechSynthesis) window.speechSynthesis.cancel(); } catch (_) { /* noop */ }

  const base = (typeof window !== 'undefined' && window.__hafizim_backend_url) || process.env.REACT_APP_BACKEND_URL || '';
  const url = `${base}/api/tts/arabic?text=${encodeURIComponent(text)}&voice=${encodeURIComponent(voice)}`;
  try {
    const audio = new Audio(url);
    currentAudio = audio;
    audio.onended = () => onEnd && onEnd();
    audio.onerror = () => {
      // Fallback to browser TTS
      speakBrowser(text, { rate, onEnd, onError });
    };
    await audio.play();
  } catch (_) {
    speakBrowser(text, { rate, onEnd, onError });
  }
}

export function ttsAvailable() {
  // Server-side TTS is always available if backend is up; browser TTS is fallback.
  return true;
}

if (typeof window !== 'undefined' && window.speechSynthesis) {
  window.speechSynthesis.onvoiceschanged = () => {
    cachedArabicVoice = null;
  };
}
